/* eslint-disable import/no-cycle */
import { ReactNode, createContext, useContext } from 'react';
import useFetchBillingPackages from '../hooks/useApi/useFetchBillingPackages';

import type { BillingPackageInfo } from '../hooks/useApi/useFetchBillingPackages';

type BillingPackages = {
  billingPackages: { dropDownOptions: { [key: string]: string }; mappedValues: { [id: string]: BillingPackageInfo } };
  refreshBillingPackages: (options?: { useCached: boolean; country?: string }) => void;
};

export const BillingPackagesContext = createContext<BillingPackages>({
  billingPackages: { dropDownOptions: {}, mappedValues: {} },
  refreshBillingPackages: () => {},
});

export const BillingPackagesProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [billingPackages, refreshBillingPackages] = useFetchBillingPackages({});

  return (
    <BillingPackagesContext.Provider
      value={{
        billingPackages,
        refreshBillingPackages,
      }}
    >
      {children}
    </BillingPackagesContext.Provider>
  );
};

export const useBillingPackages = (): BillingPackages => useContext(BillingPackagesContext);
